import React from "react";
import { Link } from "gatsby";

import Layout from "../components/layout";
import Seo from "../components/seo";
import { formatLocationBadge } from "../utils/jobs";

import "../components/Careers/Jobs/Jobs.scss";

/**
 * Statically rendered page for a single job opening, created by
 * gatsby-node.js so every position gets its own crawlable URL.
 */
const JobTemplate = ({ pageContext }) => {
  const { job, metaDescription, schemaMarkup } = pageContext;

  return (
    <Layout>
      <Seo
        title={`${job.positionTitle} - ${
          job.locationNickname || formatLocationBadge(job.location)
        }`}
        description={metaDescription}
        pathname={job.path}
        schemaMarkup={schemaMarkup}
      />
      <section className="job-detail">
        <nav className="job-detail-breadcrumb">
          <Link to="/careers/">Careers</Link> / <span>{job.positionTitle}</span>
        </nav>
        <header className="job-detail-header">
          <h1>{job.positionTitle}</h1>
          <p className="job-detail-company">{job.location}</p>
          <ul className="job-detail-facts">
            <li>
              <strong>Employment type:</strong> {job.employmentType}
            </li>
            <li>
              <strong>Expected start:</strong> {job.expectedStartDate}
            </li>
          </ul>
        </header>
        <div className="job-columns">
          <div>
            <h2>Job Description</h2>
            <ul>
              {(job.jobDescription || []).map((item, idx) => (
                <li key={`desc-${idx}`}>{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <h2>Qualifications</h2>
            <ul>
              {(job.qualifications || []).map((item, idx) => (
                <li key={`qual-${idx}`}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="job-detail-cta">
          <h2>How to Apply</h2>
          <p>
            To apply for a job with S.T.A.R. Services Group, please send a cover
            letter together with your C.V. to:
          </p>
          <a
            className="job-detail-cta-email"
            href={`mailto:hrdrecruitment.starservices@gmail.com?subject=${encodeURIComponent(
              `Application for ${job.positionTitle}`,
            )}`}
          >
            hrdrecruitment.starservices@gmail.com
          </a>
        </div>
        <p className="job-detail-back">
          <Link to="/careers/">← View all open positions</Link>
        </p>
      </section>
    </Layout>
  );
};

export default JobTemplate;
